import { Injectable } from '@angular/core';
import { IID_SLAEDITOR } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDSLAEditorStore } from './iidSLAEditor.store';
import { IIDSLAEditorQuery } from './iidSLAEditor.query';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.SLA_EDITOR)
export class IIDSLAEditorService extends CrudService<IID_SLAEDITOR, IIDSLAEditorStore, IIDSLAEditorQuery> {
  constructor(
    protected store: IIDSLAEditorStore,
    public query: IIDSLAEditorQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy) {
    super(
      Topics.IID_SLAEDITOR,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
